/* global window */
import 'es6-object-assign/auto';
import * as bi from './bi';
import {
  sanitizeRootNodes,
  throttle,
  warnAndThen,
  shouldHideHeaderAndFooter,
  addNewLanguagesToLanguagePicker,
} from './utils';
import {sanitize, useMobileVersion} from './config';
import render, {updateProfileImage, prepare} from './render';
import * as fetch from './initFetch';
import {injectFonts} from './injectFonts';
import {initWixHeader2020, shouldRenderWixHeader2020} from './wixHeaderAndFooter2020';

let inited = false;
let storedConfig;

export default function (config, nodes = {}, skipInitCheck = false) {
  if (window.IS_WIX_HEADER_2020_RENDERED) {
    if (nodes.header) {
      nodes.header.parentNode.removeChild(nodes.header);
      nodes.header = null;
    }
    if (config.useOnly === null) {
      config.useOnly = 'footer';
    } else if (config.useOnly === 'header') {
      return;
    }
  }
  if (!skipInitCheck && inited) {
    return warnAndThen('Header and footer is already embedded, don\'t do it twice');
  }
  inited = true;

  if (shouldHideHeaderAndFooter()) {
    return Promise.resolve();
  }

  config = sanitize(config);
  injectFonts(config);

  storedConfig = Object.assign({}, config);
  if (config.prerender) {
    prepare(config);
  }

  const tasks = document.cookie.indexOf('wixClient') >= 0 ?
    [fetch.experiments(), fetch.i18n(config), fetch.userDetails(config), fetch.profileImage(config)] :
    [fetch.experiments(), fetch.i18n(config)];

  return Promise.all(tasks).then(([experiments, translations, user, profileImage]) => {

    addNewLanguagesToLanguagePicker(config, experiments);

    if (shouldRenderWixHeader2020(config, experiments)) {
      initWixHeader2020(config, nodes);
    } else {
      config.hideHeader = false;
    }

    if (experiments['specs.funnel.NewHeaderAccessibilityChanges'] === 'true') {
      config.accessibilityChanges = true;
    }

    if (config.accessibilityChanges === true) {
      if (config.tabIndex && config.tabIndex[0] === 1 && config.tabIndex[1] === 0) {
        config.tabIndex = [0, 0];
      }
    }

    if (experiments['specs.marketing.EnableAnonMainFunnelIntroLinks'] === 'true') {
      if (config.language === 'en') {
        translations.signin = translations.signinAnonMainFunnel;
      }
    }

    let isMobile = useMobileVersion(config);

    if (!translations || config.useOnly === 'none') {
      return warnAndThen();
    }

    if (user) {
      user.profileImage = profileImage;
    }

    sanitizeRootNodes(nodes, config);

    window.addEventListener('resize', throttle(() => {
      if (isMobile !== useMobileVersion(config)) {
        isMobile = useMobileVersion(config);
        render(nodes, config, translations, user);
      }
    }, 200));
    render(nodes, config, translations, user);


    bi.headerAndFooterBiLogger.log({
      evid: bi.hfBiConfig.init,
      is_mobile: isMobile, // eslint-disable-line
      component: 'header'
    });
  })
    .catch(e =>
      warnAndThen('Error embedding header and footer', e)
    );
}

// support legacy wix-header-and-footer's reload() controller
export function reload() {
  if (!storedConfig || document.cookie.indexOf('wixClient') < 0) {
    return;
  }
  fetch.profileImage(storedConfig)
    .then(src => updateProfileImage(src, storedConfig));
}
